<template>
  <UiPopup
    :model-value="modelValue"
    @update:modelValue="$emit('update:modelValue', $event)"
    :onboarding="true"
    :title="$t('ordering_process_changed')"
  >
    <template #onboarding>
      <ul class="flex flex-col text-sm font-normal leading-5">
        <li>
          <IconScreen />
          {{ $t('onboarding_popup_point_one') }}
        </li>
        <li>
          <IconLeading />
          {{ $t('onboarding_popup_point_two') }}
        </li>
        <li>
          <IconCar />
          {{ $t('onboarding_popup_point_three') }}
        </li>
        <li>
          <IconBasket />
          {{ $t('onboarding_popup_point_four') }}
        </li>
        <li>
          <IconSearch />
          {{ $t('onboarding_popup_point_five') }}
        </li>
      </ul>

      <div class="mt-4 flex justify-end">
        <UiButton
          class="min-[560px]:!w-max !px-[18px] !py-[12px]"
          @click="$emit('update:modelValue', false)"
          data-qa="onboarding-popup-confirm-btn"
        >
          {{ $t('onboarding_popup_action') }}
        </UiButton>
      </div>
    </template>
  </UiPopup>
</template>

<script setup>
import UiPopup from '@/components/ui/UiPopup.vue'
import UiButton from '@/components/ui/UiButton.vue'
import IconLeading from '@/components/svg/PopupOnboarding/IconLeading.vue'
import IconScreen from '@/components/svg/PopupOnboarding/IconScreen.vue'
import IconCar from '@/components/svg/PopupOnboarding/IconCar.vue'
import IconBasket from '@/components/svg/PopupOnboarding/IconBasket.vue'
import IconSearch from '@/components/svg/PopupOnboarding/IconSearch.vue'

defineProps({
  modelValue: { type: Boolean, default: false },
})
</script>
